import { Typography } from '@room-match/shared-ui-components';
import { formattedStaticDateEnd, staticDateEnd } from 'shared/utils';
import { getDateDiffFromDateToDate } from 'shared/utils/getDateDiff';
import { Container, CustomBar, CustomButton, FlexContainer, CustomText } from './ActivePlan.styles';
import { COLORS } from 'shared/constants/COLORS';
const { PASS_TEXT, WARNING_TEXT, ERROR_TEXT } = COLORS;

const ActivePlan = () => {
  const totalDays = getDateDiffFromDateToDate(new Date(staticDateEnd), new Date());
  const getPercentage = (totalDays / 360) * 100;

  return (
    <Container>
      <FlexContainer>
        <div>
          <CustomText size={25}>Your Active Plan</CustomText>
          <Typography color="primary">Special Intro Offer</Typography>
        </div>
        <CustomButton fullWidth disabled={true}>
          Pay Now
        </CustomButton>
      </FlexContainer>
      <CustomBar percentage={0} />

      {/* Remove this UI for now. Will enable if the plans feature is already done */}
      {/* <FlexContainer>
        <Typography
          style={{
            color: getPercentage > 50 ? PASS_TEXT : getPercentage > 25 ? WARNING_TEXT : ERROR_TEXT,
          }}
        >
          {totalDays} days left
        </Typography>
        <CustomText style={{ display: 'flex', gap: 7 }}>
          Expiring on: <Typography color="primary">{formattedStaticDateEnd}</Typography>
        </CustomText>
      </FlexContainer>  */}
    </Container>
  );
};

export default ActivePlan;
